<script setup lang="ts">
import { computed } from 'vue';
import { useError } from '#app/composables/error';
import { hasErrorCode } from '#layers/base/public';
import { settingsOverlayPath } from '#layers/global-settings/public';
import { ErrorScreen } from '#layers/ui/public';
import { useWorkspaceStore } from '#layers/workspace/public';

const error = useError();

const { currentWorkspaceSlug } = useWorkspaceStore();

const isWorkspaceAccessDenied = computed(() => error.value && hasErrorCode(error.value, 'WORKSPACE_ACCESS_DENIED'));
</script>

<template>
	<div v-if="error" class="h-screen">
		<ErrorScreen :error>
			<DButton v-if="isWorkspaceAccessDenied" :to="settingsOverlayPath('organization/workspaces')">
				{{ $t('workspace.back_to_workspaces') }}
			</DButton>
			<DButton v-else-if="!currentWorkspaceSlug" to="/">
				Return to Dashboard
			</DButton>
			<DButton v-else :to="{ name: 'workspace-home', params: { workspace: currentWorkspaceSlug } }">
				Return to Workspace
			</DButton>
		</ErrorScreen>
	</div>
</template>
